(function (Drupal) {
  Drupal.behaviors.addButtonToNavbarCollapse = {
    attach: function (context, settings) {
      // Seleccionar el elemento con la clase 'navbar-collapse'
      const navbarCollapse = document.querySelector(".navbar-collapse", context);

      // Seleccionar el elemento con la clase 'navbar-main'
      const navbarMain = document.getElementById("navbar-main");

      if (navbarCollapse) {
        // Crear el botón
        const closeButton = document.createElement("button");
        closeButton.className = "btn btn-close-menu";

        // Añadir el evento click para eliminar la clase 'show'
        closeButton.addEventListener("click", function () {
          navbarCollapse.classList.remove("show");
        });

        // Añadir el botón al contenedor 'navbar-collapse'
        navbarCollapse.appendChild(closeButton);

        // Usar MutationObserver para detectar cambios en las clases
        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName === "class") {
              if (navbarCollapse.classList.contains("show")) {
                // Añadir clase al body cuando se muestra el menú
                document.body.classList.add("menu-active");
                navbarMain.style.background = "none";
              } else {
                // Quitar clase del body cuando se oculta el menú
                document.body.classList.remove("menu-active");
                navbarMain.style.background = "#FFFFFF";
              }
            }
          });
        });

        // Iniciar el observador de mutación en el navbarCollapse
        observer.observe(navbarCollapse, { attributes: true });
      }

      // Eliminando border none del btn "Agenda tu cita" en mobile
      var navItem = document.querySelector("#CollapsingNavbar .navbar-nav .nav-item:first-child");
      var firstNavItem = document.querySelector("#CollapsingNavbar .navbar-nav .nav-item:first-child a");

      if (firstNavItem.classList.contains("nav-link-https--oficinavirtualclinicacolsanitascom-")) {
        navItem.style.border = "none";
        navItem.style.marginBottom = "20px";
        firstNavItem.setAttribute("target", "_blank");
      }
    },
  };
})(Drupal);
